<template>
    <div class="flex justify-center">
        <div class="w-[50em]">
            <p class="text-center max-lg:mt-[2em] text-2xl">GUIAS MÉDICO</p>
            <div class="flex flex-col align-center justify-center mt-4">
                <div class="mx-auto">
                    <a href="https://api.saolucas.org/api/v1/rede-credenciada/pdf">
                        <button class="mt-4 w-[15em] mb-8 h-[6em] flex justify-center items-center max-lg:p-[13px] max-lg:mt-6 hover:cursor-pointer  p-6  rounded-lg font-bold tracking-wide text-white" style="background-color: #006e63;" type="button" formnovalidate>
                            
                            <span class="mr-3">COMPLETO</span>

                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 22" stroke-width="1.5" stroke="currentColor" class="size-6 mb-1">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                            </svg>
                        </button>
                    </a>
            
            
                    <a href="https://api.saolucas.org/api/v1/rede-credenciada/pdf?cidade=1614">
                        <button value="1614" class=" flex items-center justify-center w-[15em] mb-8 h-[6em] max-lg:p-[13px] max-lg:mt-6  hover:cursor-pointer  p-6  rounded-lg font-bold tracking-wide text-white" style="background-color: #006e63;" type="button" formnovalidate>

                            <span class="mr-3 ">MONTES CLAROS</span>

                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 22" stroke-width="1.5" stroke="currentColor" class="size-6 mb-1">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                            </svg>
                        </button>
                    </a>

                    <a href="https://api.saolucas.org/api/v1/rede-credenciada/pdf?cidade=1776">
                        <button value="1776" class=" flex items-center justify-center w-[15em] mb-8 h-[6em] max-lg:p-[13px] max-lg:mt-6  hover:cursor-pointer  p-6  rounded-lg font-bold tracking-wide text-white" style="background-color: #006e63;" type="button" formnovalidate>       
                            <span class="mr-3">SALINAS</span>

                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 22" stroke-width="1.5" stroke="currentColor" class="size-6 mb-1">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                            </svg>
                        </button>
                    </a>

                    <a href="https://api.saolucas.org/api/v1/rede-credenciada/pdf?cidade=1513">
                        <button class="w-[15em] mb-8 flex items-center justify-center h-[6em] max-lg:p-[13px] max-lg:mt-6  hover:cursor-pointer mr-2 p-6  rounded-lg font-bold tracking-wide text-white" style="background-color: #006e63;" value="1513" type="button" formnovalidate>

                            <span class="mr-3">JANUÁRIA</span>

                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 22" stroke-width="1.5" stroke="currentColor" class="size-6 mb-1">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                            </svg>
                        </button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>



    export default {
        name: 'downloadPDF',
    }

</script>